import { sqItemRuntimeStore, sqTrendScalingColumnStore } from '@/core/core.stores';
import { ItemRuntimeStoreProvider } from '@/trendData/itemRuntime.store';
import { TrendScalingColumnStoreProvider } from '@/trendData/trendScalingColumn.store';
import type { ReactNode } from 'react';

/**
 * Providers for the trend stores that have been converted from Flux to Zustand, wired to their
 * legacy singletons so hook readers and imperative writers share one instance.
 */
export const TrendStoreProviders = ({ children }: { children?: ReactNode }) => {
  return (
    <TrendScalingColumnStoreProvider store={sqTrendScalingColumnStore}>
      <ItemRuntimeStoreProvider store={sqItemRuntimeStore}>{children}</ItemRuntimeStoreProvider>
    </TrendScalingColumnStoreProvider>
  );
};
